module.exports = __webpack_public_path__ + "static/assets/18ef2b16b2d0a984e3655c1c9ff13488.jpg";